import React from "react";
import Head from "./Fields/Head";
import TextInput from "../../../form/TextInput";
import {CurrencyFormatter} from "../../../../utils/formatters";
import createForm from "../Form";

class ExternalInvoiceForm extends React.Component {
    render() {
        const disabled = (this.props.values || {}).type + "" !== "999";
        return (
            <form onSubmit={this.props.handleSubmit}>
                <Head {...this.props} correctable={true} external={true}/>
                {/*<Items {...this.props} />*/}
                <div className="row form-row">
                    <div className="col-md-6">
                        <TextInput
                            name="amount"
                            disabled={disabled}
                            value={this.props.values.amount}
                            label="Végösszeg"
                            formatter={CurrencyFormatter}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-6">
                        <TextInput
                            name="vat_amount"
                            disabled={disabled}
                            value={this.props.values.vat_amount}
                            label="Áfa összeg"
                            formatter={CurrencyFormatter}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(ExternalInvoiceForm);